import React from 'react'
import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import { MetadataIconStyles, StyledIconContainer } from '../index.css'

const StyledMetadataLink = styled.a`
  color: ${({ mode }: { mode: Theme }) => sys[mode].interaction.primary.default};
  white-space: nowrap;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  text-decoration: none;
`

const StyledMetadataIconContainer = styled.div`
  ${MetadataIconStyles}
  &:hover {
    background: ${({ mode }: { mode: Theme }) => sys[mode].interaction.onElevation.default};
  }
`

type LinkedMetadataIconsContainerProps = {
  children: React.ReactElement
  message: string
  url: string
}

const LinkedMetadataIconsContainer = ({
  children,
  message,
  url
}: LinkedMetadataIconsContainerProps) => {
  const theme = useDisplayTheme() as Theme

  return (
    <StyledMetadataLink
      href={url}
      target="_blank"
      rel="noreferrer"
      mode={theme}
      onClick={(event) => {
        event.stopPropagation()
      }}>
      <StyledMetadataIconContainer mode={theme}>
        <StyledIconContainer> {children}</StyledIconContainer>
        {message}
      </StyledMetadataIconContainer>
    </StyledMetadataLink>
  )
}

export default LinkedMetadataIconsContainer
